module.exports = __webpack_public_path__ + "static/btn.be31b783.png";